export default __webpack_public_path__ + "static/media/automation-full-macos.999b2e43.avif";